import NoDataAndLoading from 'components/NoDataAndLoading'
import {Link} from 'react-router'
import styles from './EmptyState.css'
import {Popover, OverlayTrigger} from 'react-bootstrap'

class EmptyState extends React.Component {
  render () {
    const {showLoadingSpinner, hasRole, hasStaff} = this.props
    const {title, description, linkLabel, linkUrl} = this._text()
    return <NoDataAndLoading
      showLoadingSpinner={showLoadingSpinner}
      noDataToDisplay={!hasRole || !hasStaff}
      title={title}
      description={description}
      linkLabel={linkLabel}
      linkUrl={linkUrl}
    />
  }

  _text = () => {
    const {hasRole, hasStaff} = this.props
    if (hasRole && hasStaff) {
      return {title: '', description: ''}
    } else if (hasRole && !hasStaff) {
      return {title: 'No staff information', description: '', linkLabel: 'Invite Staffs to The Role', linkUrl: 'https://mokaposhelp.zendesk.com/hc/en-us/articles/115003688633-Invite-Staffs-to-The-Role'}
    } else { //! hasRole
      return {title: 'No staff information', description: 'You must have at least one role to invite a staff'}
    }
  }

  _footerElement = () => {
    const {hasRole, canAccessRole} = this.props
    if (hasRole) {
      return false
    } else {
      if (canAccessRole) {
        return <Link to='/employees/role'
          className={`btn btn-primary btn-lg ${styles['btn-create-role']}`}>Create A Role</Link>
      } else {
        const popover = (<Popover bsClass={`${styles.popover} popover`}>
          You're not authorized to access this privilege
        </Popover>)
        return <OverlayTrigger placement='top' overlay={popover}>
          <a className={`btn btn-primary btn-lg ${styles['btn-create-role']} ${styles['disabled']}`}>
              Create A Role
            </a>
        </OverlayTrigger>
      }
    }
  }
}

EmptyState.propTypes = {
  hasRole: React.PropTypes.boolean,
  hasStaff: React.PropTypes.boolean,
  canAccessRole: React.PropTypes.boolean,
  showLoadingSpinner: React.PropTypes.boolean
}

export default EmptyState



// WEBPACK FOOTER //
// ./app/pages/Employees/Staff/EmptyState/EmptyState.js